<template>
  <ol class="breadcrumb px-0 py-1">
    <font-awesome-icon icon="home" class="home-icon"/>
    <li class="breadcrumb-item" v-for="(url, name, index) in values" :key="`breadcrumb-${index}`">
      <router-link v-if="url" :to="url">
        <span>{{ name.toUpperCase() || '' }}</span>
      </router-link>
      <span v-else>{{ name.toUpperCase() || '' }}</span>
    </li>
  </ol>
</template>

<script>
export default {
  name: 'Breadcrumb',
  props: {
    values: Object
  }
}
</script>

<style lang="scss" scoped>
@import "../../assets/scss/variables";

.breadcrumb {
  font-family: 'Source Sans Pro', sans-serif;
  font-size: 11px;
  line-height: 20px;
  letter-spacing: 0;
  color: $default-focus;
  font-weight: 900;
  background-color: rgba(255,255,255,0.9);
  .home-icon {
    margin: auto 30px;
    font-size: 16px;
    color: $home-card;
  }
  a {
    color: $home-card;
    font-weight: 400;
  }
  .breadcrumb-item {
    &:before {
      color: $home-card;
    }
  }
}
</style>
